var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLanguageMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 21.25H9.5C6.575 21.25 4.25 18.925 4.25 16V13H5.75V16C5.75 18.1 7.4 19.75 9.5 19.75H11.75V21.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 22.75H22.4L18.95 14.5H17.3L13.85 22.75H15.5L16.1 21.25H20.075L20.75 22.75ZM16.775 19.75L18.125 16.45L19.475 19.75H16.775Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 11.5H19.25V8.5C19.25 6.4 17.6 4.75 15.5 4.75H12.5V3.25H15.5C18.425 3.25 20.75 5.575 20.75 8.5V11.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 4V2.5H6.5V1H5V2.5H1.25V4H7.4C7.25 4.675 6.8 5.875 5.75 7C5.3 6.475 4.925 5.95 4.7 5.5H2.975C3.275 6.25 3.8 7.15 4.55 7.975C3.95 8.5 3.05 8.95 2 9.325L2.525 10.75C3.875 10.225 4.925 9.625 5.75 9.025C6.575 9.7 7.625 10.3 8.975 10.75L9.5 9.325C8.45 8.95 7.55 8.425 6.875 7.975C8.3 6.475 8.75 4.9 8.9 4H10.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLanguageMenu);
export default __webpack_public_path__ + "static/media/ic-language-menu.7982149353c71223b1dbf395a3e90ee5.svg";
export { ForwardRef as ReactComponent };